module.exports = __webpack_public_path__ + "static/media/postoffice.e1b246fb.svg";